import KySoConfigPage from "./KySoConfigPage";

export default KySoConfigPage